var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDropLocation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 4,
    fill: "#313131"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1170_1412)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.8333 2L11.1667 2V5.38491C8.15106 5.76095 5.76095 8.15107 5.38491 11.1667H2L2 12.8333H5.38491C5.76095 15.8489 8.15106 18.239 11.1667 18.6151L11.1667 22H12.8333L12.8333 18.6151C15.8489 18.239 18.239 15.8489 18.6151 12.8333H22V11.1667H18.6151C18.239 8.15107 15.8489 5.76095 12.8333 5.38491V2ZM17.5556 12C17.5556 15.0682 15.0682 17.5556 12 17.5556C8.93176 17.5556 6.44444 15.0682 6.44444 12C6.44444 8.93175 8.93176 6.44444 12 6.44444C15.0682 6.44444 17.5556 8.93175 17.5556 12ZM9.82986 11.2929L12 8.11111L14.1701 11.2929L14.1692 11.2938C14.55 11.7778 14.7778 12.3921 14.7778 13.0606C14.7778 14.6226 13.5341 15.8889 12 15.8889C10.4659 15.8889 9.22222 14.6226 9.22222 13.0606C9.22222 12.3921 9.44998 11.7778 9.8308 11.2938L9.82986 11.2929ZM14.0833 13.7677C14.0833 14.5487 13.4615 15.1818 12.6944 15.1818C11.9274 15.1818 11.3055 14.5487 11.3055 13.7677C11.3055 12.9867 11.9274 12.3535 12.6944 12.3535C13.4615 12.3535 14.0833 12.9867 14.0833 13.7677Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1170_1412"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(2 2)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDropLocation);
export default __webpack_public_path__ + "static/media/DropLocation.c93b7345e08edca9900ecfff079d8427.svg";
export { ForwardRef as ReactComponent };